import { computed, reactive, ref } from 'vue'

import sessionStore from '@shared/store/session'
import softloginAPI from '@shared/api/softlogin'
import useI18n from '@shared/hooks/useI18n'
import useSession from '@shared/hooks/useSession'

import { ReactivityUtil } from '@shared/utils/Reactivity'
import PersonHelper from '@shared/helpers/Person'

// HOOKS
const { autostart } = useSession()
const { selectedLanguage } = useI18n()

// DATA
const channel = ref(null)
const basket = reactive({})
let promise

export default function useSoftlogin() {

  const basketOfferEditScope = computed(() => {
    return basket.basketOfferEditScope
  })

  const contractOwner = computed(() => {
    if (!basket?.contractOwner?.personId) return {}

    const contractOwnerPersonIndex = basket.persons.findIndex(person => person.personId === basket.contractOwner.personId)

    return PersonHelper.getPersonDetails(
      people.value[contractOwnerPersonIndex],
      contractOwnerPersonIndex
    )
  })

  const people = computed(() => {
    return ReactivityUtil.clone(basket).persons
      ?.filter(person => !!person.contractNumber)
      ?.map((person, index) => {
        const _person = Object.assign(
          PersonHelper.getPersonDetails(person, index),
          person
        )
        _person.selected = false

        switch (_person.personData.gender) {
          case 'MALE':
            _person.icon = 'user-hair'
            break

          case 'FEMALE':
            _person.icon = 'user-hair-long'
            break

          case 'UNBORN':
            _person.icon = 'baby'
            break
        }

        return _person
      })
  })

  function createSoftloginBasket(payload) {
    return softloginAPI.createSoftloginBasket(payload, [])
  }

  function verifyCustomerData(payload) {
    return softloginAPI.verifyCustomerData(payload, ['DVP_ACCOUNT_LOCKED', 'DVP_VERIFICATION_FAILED'])
  }

  function verifyCustomerTAN(payload) {
    return softloginAPI.verifyCustomerTAN(payload, ['DVP_ACCOUNT_LOCKED', 'DVP_VERIFICATION_FAILED'])
  }

  async function setTemporaryBasket(payload) {
    ReactivityUtil.reAssign(basket, payload)

    if (Object.keys(payload).length > 0) {
      await sessionStore.setSession(basket, { preventCookie: true })

      // @note: if payload is empty, clear and restart session -> cancel
    } else if (Object.keys(basket).length > 0) {
      await sessionStore.clearSession()
      await autostart({ language: selectedLanguage.value })
    }
  }

  return {
    basket,
    basketOfferEditScope,
    channel,
    contractOwner,
    createSoftloginBasket,
    people,
    promise,
    setTemporaryBasket,
    verifyCustomerData,
    verifyCustomerTAN,
  }
}
